export default class QuantityInput extends HTMLElement {
    constructor() {
        super();
        this.input = this.querySelector('input');
        if (this.input) {
            this.maxValue = this.input.max;
            this.minValue = this.input.min;
            this.disableButtons();
            this.debouncedOnChange = debounce((event) => {
                this.onChange(event);
            }, 300);

            this.addEventListener('change', this.debouncedOnChange.bind(this));
        }
        this.changeEvent = new Event('change', { bubbles: true })

        this.querySelectorAll('button').forEach(
            (button) => button.addEventListener('click', this.onButtonClick.bind(this))
        );

    }

    onChange(event) {
        this.disableButtons();
    }

    disableButtons(event) {
        this.currentValue = this.input.value;
        this.querySelector('[name="plus"]').disabled = this.maxValue == this.currentValue;

        this.querySelector('[name="minus"]').disabled = this.minValue == this.currentValue;
    }

    onButtonClick(event) {
        event.preventDefault();
        const previousValue = this.input.value;

        event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
        if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
    }
}
